import { LoginCard } from './LoginCard'
import logoLeao from '../../assets/logo-leao.png'

export function LoginPage() {
  return (
    <div className="relative flex min-h-screen flex-col bg-bg">
      <div
        className="absolute inset-x-0 top-0 h-[380px] bg-sidebar"
        style={{ backgroundImage: 'radial-gradient(circle at 20% 20%, rgba(255,179,0,0.18), transparent 45%), radial-gradient(circle at 85% 0%, rgba(255,106,0,0.14), transparent 40%)' }}
        aria-hidden
      />

      <div className="relative flex flex-1 flex-col items-center px-4 pt-14 pb-8">
        <div className="mb-8 text-center">
          <div className="inline-flex flex-col items-center gap-2">
            <img src={logoLeao} alt="" className="h-24 w-auto" />
            <span className="text-xl font-bold tracking-[0.2em] text-white">WALLEON</span>
          </div>
          <p className="mt-3 text-15 text-white/70">Proteja. Organize. Evolua.</p>
        </div>

        <LoginCard />
      </div>

      <footer className="relative pb-6 text-center text-13 text-muted">
        {new Date().getFullYear()} © Walleon. Todos os direitos reservados.
      </footer>
    </div>
  )
}
